import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { FeatureToggleResponse } from 'src/app/core/models/feature-toggle-response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FeatureTogglesApiService {
    baseUrl: string = environment.apiUrl;
    featureTogglesUrlSuffix = 'v3/featuretoggles';
    private static featureToggles: FeatureToggleResponse[];

    constructor(private httpClient: HttpClient) {}

    async getFeatureToggles() {
        FeatureTogglesApiService.featureToggles = await lastValueFrom(
            this.httpClient.get<FeatureToggleResponse[]>(`${this.baseUrl}${this.featureTogglesUrlSuffix}`)
        );
    }

    getCachedFeatureToggles(): FeatureToggleResponse[] {
        return FeatureTogglesApiService.featureToggles;
    }
}
